<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <label for="">{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              id="farm_pathmap"
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 required-farm shadow-sm"
              v-model="pathMapReportForm.farm_id"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in farms"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-12 col-md-2 col-lg-2">
            <label>{{ $t('common_words.analyze_by') }} </label>
            <br />
            <el-select
              @change="changeByInterval"
              filterable
              @clear="pathMapReportForm.bySel = null"
              clearable
              class="select-primary custom-width-select shadow-sm"
              size="large"
              v-model="pathMapReportForm.bySel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in Object.values(optionsInterval)"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
            v-if="
              pathMapReportForm.bySel != 'week' &&
              pathMapReportForm.bySel != 'year'
            "
          >
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              v-model="rangeDate"
              class="shadow-sm"
              v-bind:type="typedatepicket"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
              :start-placeholder="$t('common_words.initial_date')"
              :end-placeholder="$t('common_words.final_date')"
            >
            </el-date-picker>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-right: 0; padding-top: 29px"
            v-if="
              pathMapReportForm.bySel == 'week' ||
              pathMapReportForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="pathMapReportForm.year_sel_init"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              pathMapReportForm.bySel == 'week' &&
              pathMapReportForm.year_sel_init
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="pathMapReportForm.week_sel_init"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              pathMapReportForm.bySel == 'week' ||
              pathMapReportForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="pathMapReportForm.year_sel_end"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              pathMapReportForm.bySel == 'week' &&
              pathMapReportForm.year_sel_end
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="pathMapReportForm.week_sel_end"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
      <card v-if="pathMapReport">
        <div class="row">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="pathMapReport"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="pathMapReport"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts.js';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  computed: {
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.avancedReportForm.bySel
        ).label;
      } catch (error) {
        return 'Intervalo';
      }
    },
  },
  data() {
    return {
      pathMapReportForm: {
        bySel: 'Semana',
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        diseases_ids: [],
        farm_id: null,
      },
      typedatepicket: 'daterange',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      searchQuery: '',
      pointsData: [],
      farms: [],
      years: [],
      diseases: [],
      pathMapReport: false,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    changeByInterval() {
      this.pathMapReport = false;
      this.typedatepicket = this.pathMapReportForm.bySel;
    },

    validate() {
      if (this.pathMapReportForm.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (
        this.pathMapReportForm.bySel != 'daterange' &&
        this.pathMapReportForm.bySel != 'monthrange' &&
        (this.pathMapReportForm.year_sel_init == null ||
          this.pathMapReportForm.year_sel_end == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isYearSelRequired() &&
        this.pathMapReportForm.year_sel_end == null &&
        this.pathMapReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.pathMapReportForm.week_sel_init == null &&
        this.pathMapReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.pathMapReportForm.week_sel_end == null &&
        this.pathMapReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.rangeDate == null) {
        return this.validationInputsRequired('year');
      } else {
        this.loadPathMapReport();
      }
    },

    loadData() {
      let data = {
        farm: this.pathMapReportForm.farm_id,
        init: null,
        end: null,
        bySel: this.pathMapReportForm.bySel,
        diseases: this.pathMapReportForm.diseases_ids,
      };

      switch (this.pathMapReportForm.bySel) {
        case 'year':
          data.init = this.pathMapReportForm.year_sel_init;
          data.end = this.pathMapReportForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
        case 'week':
          data.init = `${this.pathMapReportForm.year_sel_init}-${(
            '0' + this.pathMapReportForm.week_sel_init
          ).slice(-2)}`;
          data.end = `${this.pathMapReportForm.year_sel_end}-${(
            '0' + this.pathMapReportForm.week_sel_end
          ).slice(-2)}`;
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadPathMapReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'diseases/pathmap';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.pointsData = response.data.data;
            this.pathMapReport = true;
            if (this.pointsData.length == 0) {
              SweetAlert.warning(
                i18n.t('sweet_alert.disease.unavailable_dates')
              );
            }
          }

          for (let index = 0; index < this.farms.length; index++) {
            if (this.farms[index].id == this.pathMapReportForm.farm_id) {
              this.center = {
                lat: this.farms[index].latitude,
                lng: this.farms[index].longitude,
              };
            }
          }
          setTimeout(() => {
            this.loadTrackMap(
              this.pathMapReportForm.farm_id,
              this.pointsData,
              this.center,
              true,
              true,
              this.$refs.map,
              20
            );
            document.getElementById('toolbarDiv').style =
              'top: 12.5%;right: 30px;';
          }, 10);

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'week';
    },

    isWeekSekRequired() {
      return this.interval == 'week';
    },

    deleteRecordingMap(recordingCode) {
      SweetAlert.delete(
        i18n.t('sweet_alert.disease.delete_selected_path')
      ).then((result) => {
        if (result.value) {
          const data = {
            id: recordingCode,
            route: 'diseases/pathmap',
          };
          this.showHideLoading(true);
          Axios.destroyMaster(data)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then((result) => {
                if (result.value) this.loadPathMapReport();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        }
      });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('diseases/diseasesonly'),
      ])
        .then((response) => {
          this.farms = response[0].data.data;
          this.diseases = response[1].data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('diseases/pathmap/years').then((response) => {
      this.years = response.data;

      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases');
  },
};
</script>

<style scoped></style>
